<script>
import { stringToPredefinedColourSet } from '@/helpers/color-helpers'

// Predefined color sets matching the original pill styles
const colorSets = {
  blue: { background: '#ecfaff', foreground: '#005997' },
  purple: { background: '#f7f6ff', foreground: '#3c3087' },
}

export default {
  name: 'BaseChip',
  props: {
    variant: {
      type: String,
      default: 'blue',
      validator: (val) => ['blue', 'purple', 'auto'].includes(val),
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    chipColors() {
      if (this.variant === 'auto') {
        // Use the title prop, or fall back to slot text if available
        const colorKey = this.title || ''
        return stringToPredefinedColourSet(colorKey)
      }
      return colorSets[this.variant]
    },
    chipStyle() {
      return {
        backgroundColor: this.chipColors.background,
        color: this.chipColors.foreground,
      }
    },
  },
}
</script>

<template>
  <v-chip label small class="base-chip" :title="title" :style="chipStyle">
    <slot>
      {{ title }}
    </slot>
  </v-chip>
</template>

<style lang="scss" scoped>
.base-chip {
  max-width: 200px;
  height: 26px;
  margin: 2px 8px 2px 0;
  overflow: hidden;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
